<template>
  <div
    :id="question.uuid + '-question'"
    class="panel"
    v-if="component_done_loading"
  >
    <div class="panel-heading flexSpaceBetween">
      <div>QUESTION {{ getQuestionNo(question_group_idx, question_idx) }}</div>
      <template
        v-if="
          question.type == 'openended' &&
            question.eGallery.status == 'ongoing' &&
            question.eGalleryWalkSettings.startTime != null
        "
      >
        <div class="timer_Div darkGreen flex align-items justifyCenter" :class="{'miniTimer' : miniTimerVisible}">
          <div>
            <div class="timeText">
              MINUTES
            </div>
            <div class="time flex">
              <div class="number-div">{{ time.minutes.charAt(0) }}</div>
              <div class="number-div">{{ time.minutes.charAt(1) }}</div>
            </div>
          </div>

          <div class="colon">:</div>

          <div>
            <div class="timeText">
              SECONDS
            </div>
            <div class="time flex">
              <div class="number-div">{{ time.seconds.charAt(0) }}</div>
              <div class="number-div">{{ time.seconds.charAt(1) }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="panel-body eGallery-panel">
      <template v-if="question.type == 'mcqs' || question.type == 'mcqm'">
        <mcq :testObj="testObj" :question="question"></mcq>
      </template>
      <template v-else-if="question.type == 'openended'">
        <openended :testObj="testObj" :question="question"></openended>
      </template>
    </div>

    <div
      class="modal modal-manual"
      :id="question.uuid + '-enlarge-image-modal'"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="'enlargeImageModal-' + question.uuid + '-title'"
      data-keyboard="false"
      data-backdrop="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close Modal"
            >
              <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>

            <h4
              :id="'enlargeImageModal-' + question.uuid + '-title'"
              class="modal-title"
            >
              <i class="fa fa-arrows marginRight8" aria-hidden="true"></i>Enlarged Image
            </h4>
          </div>
          <div class="modal-body padding0">
            <img :src="srcValue" :key="srcValue" width="100%">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { testMixins } from "./../../../../../../../../mixins/test";
export default {
  props: ["testObj", "question", "question_group_idx", "question_idx"],
  mixins: [testMixins],
  data() {
    return {
      component_done_loading: false,
      timer: null,
      time: { minutes: "00", seconds: "00" },
      scrollFunction: null,
      miniTimerVisible: false,
      srcValue: '',
    };
  },
  created() {
    var that = this; 

    this.component_done_loading = true;
    
    this.scrollFunction = function () {
      if (this.testObj.others.applicationType == "team" && $(window).scrollTop() > 407 || this.testObj.others.applicationType != "team" && $(window).scrollTop() > 322) {
        that.miniTimerVisible = true;
      } else {
        that.miniTimerVisible = false;
      }
    }.bind(this);

    Vue.nextTick(function() {
      that.scrollFunction();

      $(
        "#" + that.question.uuid + "-enlarge-image-modal"
      ).draggable();
    });
  },
  mounted() {
    window.addEventListener('click', (event) => {
      const isImg = event.target.nodeName === 'IMG';
      if (!isImg) {
        return;
      }

      var questionUUID = event.target.closest('.panel').getAttribute('id').slice(0, 36);
      this.openEnlargeImageModal(event.target.src, questionUUID);
    });

    if (
      this.question.type == "openended" &&
      ["ongoing"].includes(this.question.eGallery.status) &&
      this.question.eGalleryWalkSettings.timeLimitInMinutes
    ) {
      this.initTimer();
    }

    window.addEventListener("scroll", this.scrollFunction);
  },
  beforeDestroy() {
    window.removeEventListener('click', (event) => {
      const isImg = event.target.nodeName === 'IMG';
      if (!isImg) {
        return;
      }

      var questionUUID = event.target.closest('.panel').getAttribute('id').slice(0, 36);
      this.openEnlargeImageModal(event.target.src, questionUUID);
    });

    window.removeEventListener("scroll", this.scrollFunction);
  },
  methods: {
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    initTimer() {
      var that = this;
      this.stopTimer();
      var startTime = this.convertToReadableDate(
        _.get(this.question.eGalleryWalkSettings, "startTime", "")
      ).dateObj;
      var endTime = startTime.add(
        this.question.eGalleryWalkSettings.timeLimitInMinutes,
        "minutes"
      );
      this.timer = setInterval(function(startTime) {
        var now = startTime;
        var distance = moment.duration(endTime.diff(now));
        if (distance > 0) {
          that.time.minutes = (
            "0" +
            (distance.minutes() + distance.hours() * 60)
          ).slice(-2);
          that.time.seconds = ("0" + distance.seconds()).slice(-2);
        } else {
          that.time.minutes = "00";
          that.time.seconds = "00";
        }
      }, 1000);
    },
    openEnlargeImageModal(src, id) {
      if (id == this.question.uuid) {
        $("#" + this.question.uuid + "-enlarge-image-modal").modal("show");

        this.srcValue = src;

        $(
          "#" + this.question.uuid + "-enlarge-image-modal"
        ).resizable({
          handles: 'ne, se, sw, nw'
        });
      }
    },
  },
  watch: {
    question: {
      handler: function() {
        if (
          this.question.type == "openended" &&
          ["ongoing"].includes(this.question.eGallery.status) &&
          this.question.eGalleryWalkSettings.timeLimitInMinutes
        ) {
          this.initTimer();
        }
      },
      deep: true,
    },
    openEnlargeImageModal(src, id) {
      if (id == this.question.uuid) {
        $("#" + this.question.uuid + "-enlarge-image-modal").modal("show");

        this.srcValue = src;

        $(
          "#" + this.question.uuid + "-enlarge-image-modal"
        ).resizable({
          handles: 'ne, se, sw, nw'
        });
      }
    },
  },
  components: {
    mcq: require(`./partials/mcq.vue`).default,
    openended: require(`./partials/openended.vue`).default,
  },
};
</script>
<style lang="scss" scoped>
.timer_Div {
  .time .number-div {
    background: #fff;
    padding: 6px;
    border-radius: 3px;
    font-size: 28px;
    font-weight: bold;
    line-height: 0.8;
  }

  .time .number-div:last-child {
    margin-left: 5px;
  }

  .colon {
    color: #fff;
    padding: 0 10px;
  }

  .timeText {
    // font-size: 14px;
    font-size: 0.778rem;
    margin-bottom: 5px;
  }
}

.miniTimer {
  position: fixed;
  top:10px;
  right:100px;
  z-index: 1001;


  &.timer_Div {
    .timeText {
      text-align: center;
      font-size: 10px;
    }
    .time {
      .number-div {
       font-size: 20px; 
      }
    }
  } 
}
</style>
